import Project1 from '../images/projects/Project1/main.png'
import image11 from '../images/projects/Project1/image1.png'
import image12 from '../images/projects/Project1/image2.png'
import image13 from '../images/projects/Project1/image3.png'
import image14 from '../images/projects/Project1/image4.png'
import image15 from '../images/projects/Project1/image5.png'

import Project2 from '../images/projects/Project2/main.png'
import image21 from '../images/projects/Project2/image1.png'
import image22 from '../images/projects/Project2/image2.png'
import image23 from '../images/projects/Project2/image3.png'
import image24 from '../images/projects/Project2/image4.png'
import image25 from '../images/projects/Project2/image5.png'

import Project3 from '../images/projects/Project3/main.png'
import image31 from '../images/projects/Project3/image1.png'
import image32 from '../images/projects/Project3/image2.png'
import image33 from '../images/projects/Project3/image3.png'
import image34 from '../images/projects/Project3/image4.png'
import image35 from '../images/projects/Project3/image5.png'

import Project4 from '../images/projects/Project4/main.png'
import image41 from '../images/projects/Project4/image1.png'
import image42 from '../images/projects/Project4/image2.png'
import image43 from '../images/projects/Project4/image3.png'
import image44 from '../images/projects/Project4/image4.png'
import image45 from '../images/projects/Project4/image5.png'

const ProjectImage = {
    Project1: {
        main: Project1,
        others: [
            image11, image12, image13, image14, image15, 
        ]
    },
    Project2: {
        main: Project2,
        others: [
            image21, image22, image23, image24, image25, 
        ]
    },
    Project3: {
        main: Project3,
        others: [
            image31, image32, image33, image34, image35, 
        ]
    },
    Project4: {
        main: Project4,
        others: [
            image41, image42, image43, image44, image45, 
        ]
    },
}

export default ProjectImage;